import Polyline from '@mapbox/polyline';
import { api, isNullOrUndefined } from "common";
import { FareCalculatorNew } from "./FareCalculator";
import { II18nextTypes } from "common/src/types/i18n";
import { IApiDirectionsResultType, IEstimateType, ISettingsType, ITripDataType } from "common/src/types";

interface IPrepareEstimateObjectProps {
    tripdata: ITripDataType
    settings: ISettingsType
}


export const PrepareEstimateObjectNew = async ({ tripdata, settings }: IPrepareEstimateObjectProps): Promise<{ msg?: keyof II18nextTypes; error?: boolean; estimateObject?: IEstimateType }> => {

    const {
        getDirectionsApi
    } = api;

    try {
        if (isNullOrUndefined(tripdata.pickup)) {
            return { error: true, msg: "select_pickup_location" }
        }

        if (isNullOrUndefined(tripdata.drop)) {
            return { error: true, msg: "drop_location_blank_error" }
        }

        if (isNullOrUndefined(tripdata.carType?.name)) {
            return { error: true, msg: 'car_type_blank_error' }
        }


        let tripFormat = tripdata;

        const findCity = tripFormat?.carType?.cities?.find(
            ({ city }: any) => {
                let formatCity = city.split(" - ");

                if (tripFormat?.pickup?.add?.includes(formatCity[0])) {
                    return city;
                }
            }
        );




        if (findCity) {
            tripFormat.carType = {
                ...tripFormat.carType!,
                min_fare: findCity.min_fare,
                base_fare: findCity.base_fare,
                rate_per_hour: findCity.rate_per_hour,
                convenience_fees: findCity.convenience_fees,
                rate_per_unit_distance: findCity.rate_per_unit_distance,
            };
        }


        const startLoc = tripFormat.pickup.lat + ',' + tripFormat.pickup.lng;
        const destLoc = tripFormat.drop.lat + ',' + tripFormat.drop.lng;

        let waypoints = '';
        let routeDetails: IApiDirectionsResultType | undefined = undefined;


        if (tripFormat.drop && tripFormat.drop.waypoints && tripFormat.drop.waypoints.length > 0) {
            const origin = tripFormat.pickup.lat + ',' + tripFormat.pickup.lng;
            const arr = tripFormat.drop.waypoints;
            for (let i = 0; i < arr.length; i++) {
                waypoints = waypoints + arr[i].lat + ',' + arr[i].lng;
                if (i < arr.length - 1) {
                    waypoints = waypoints + '|';
                }
            }
            const destination = tripFormat.drop.lat + ',' + tripFormat.drop.lng;
            routeDetails = await getDirectionsApi(origin, destination, waypoints);
        } else {
            routeDetails = await getDirectionsApi(startLoc, destLoc, undefined);
        }


        let estimateObject: Partial<IEstimateType> = {
            pickup: {
                coords: { lat: Number(tripFormat.pickup.lat), lng: Number(tripFormat.pickup.lng) },
                description: tripFormat.pickup.add
            },
            drop: {
                description: tripFormat.drop.add,
                waypointsStr: waypoints != '' ? waypoints : null,
                waypoints: waypoints != '' ? tripFormat.drop.waypoints : null,
                coords: { lat: Number(tripFormat.drop.lat), lng: Number(tripFormat.drop.lng) },
            },
            carDetails: tripFormat.carType,
            routeDetails: routeDetails,
        };




        if (estimateObject && estimateObject.routeDetails && estimateObject.carDetails) {

            let points = Polyline.decode(estimateObject.routeDetails.polylinePoints);

            let waypoints = points.map((point) => {
                return {
                    latitude: point[0],
                    longitude: point[1]
                }
            });

            let distance = settings.convert_to_mile ? (estimateObject.routeDetails.distance_in_km / 1.609344) : estimateObject.routeDetails.distance_in_km;

            const FareCalculatorResult = FareCalculatorNew({ carType: estimateObject.carDetails, estimate: estimateObject, settings: settings });

            if (FareCalculatorResult.error) {
                return { error: FareCalculatorResult.error, msg: FareCalculatorResult.msg }
            }

            let { totalCost, grandTotal, convenience_fees } = FareCalculatorResult.fare!;

            estimateObject = {
                waypoints: waypoints as any,
                drop: estimateObject.drop,
                pickup: estimateObject.pickup,
                carDetails: estimateObject.carDetails,
                routeDetails: estimateObject.routeDetails,
                estimateTime: parseFloat(estimateObject.routeDetails.time_in_secs),
                estimateDistance: parseFloat(parseFloat(String(distance)).toFixed(settings.decimal)),
                fareCost: totalCost ? parseFloat(parseFloat(String(totalCost)).toFixed(settings.decimal)) : 0,
                estimateFare: grandTotal ? parseFloat(parseFloat(String(grandTotal)).toFixed(settings.decimal)) : 0,
                convenience_fees: convenience_fees ? parseFloat(parseFloat(String(convenience_fees)).toFixed(settings.decimal)) : 0,
            }

            return { estimateObject: estimateObject as any };
        }
        else {
            return { error: true, msg: 'error' }
        }
    } catch (error) {
        return { error: true, msg: error as any }
    }
}